module.exports = __webpack_public_path__ + "img/tn-timeline-misc-11.c7114ce1.jpg";